import React, { useState, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import { Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TwTooltip from '../TwTooltip/TwTooltip';
import { InfoIcon } from './TwGrossPayTooltip.styles';
import { LOAD_TYPE } from '../../redux/api/load/load.model';
import useFeatureFlags from '../../providers/FeatureFlags/FeatureFlags.provider';
import { TRIP_DRIVER_PAY_UNIT, TripDriverOverrideData } from '../../redux/api/trips/trips.model';

export interface TwGrossPayTooltipProps {
  grossPayData: TripDriverOverrideData;
  showLabel?: boolean;
  loadType: LOAD_TYPE;
  numberOfDrivers: number;
  otherPayItemsTotalAmount: number;
}

const TwGrossPayTooltip: React.FC<TwGrossPayTooltipProps> = ({
  grossPayData,
  showLabel,
  loadType,
  numberOfDrivers,
  otherPayItemsTotalAmount
}) => {
  const { enableOtherPayInDriverPayModal } = useFeatureFlags();
  const [tooltipText, setTooltipText] = useState<string>('');

  useEffect(() => {
    switch (grossPayData.unit) {
      //  case PAY_TYPES.PER_MILE:
      case TRIP_DRIVER_PAY_UNIT.PER_MILE:
        setTooltipText(
          `Driver pay estimated based on driver's per mi rate: $${grossPayData.rate} per mi x (${
            grossPayData?.loaded_miles
          } loaded mi + ${grossPayData?.empty_miles || 0} empty mi) ${
            enableOtherPayInDriverPayModal ? `+ $${otherPayItemsTotalAmount} other trip pay` : ''
          }`
        );
        break;

      // case PAY_TYPES.PERCENTAGE:
      case TRIP_DRIVER_PAY_UNIT.PERCENTAGE:
        if (loadType === LOAD_TYPE.SEGMENT) {
          setTooltipText(
            `Driver pay estimated based on driver's percentage rate: ${
              grossPayData.rate || 0
            }% x ((${grossPayData.trip_revenue_percentage || 0}% x ${
              grossPayData.overriden_order_rate
            }) / ${numberOfDrivers} driver(s)) ${
              enableOtherPayInDriverPayModal ? `+ $${otherPayItemsTotalAmount} other trip pay` : ''
            }`
          );
        } else {
          setTooltipText(
            `Driver pay estimated based on driver's percentage rate: ${Number(
              grossPayData.rate
            )}% x (${`$${grossPayData?.overriden_order_rate}`} / ${numberOfDrivers} driver(s)) ${
              enableOtherPayInDriverPayModal ? `+ $${otherPayItemsTotalAmount} other trip pay` : ''
            }`
          );
        }

        break;

      // case PAY_TYPES.PER_HOUR:
      case TRIP_DRIVER_PAY_UNIT.PER_HOUR:
        setTooltipText(
          `Driver pay estimated based on driver's hourly rate: $${grossPayData.rate} per hr x ${
            grossPayData.quantity
          } hours ${
            enableOtherPayInDriverPayModal ? `+ $${otherPayItemsTotalAmount} other trip pay` : ''
          }`
        );
        break;

      case TRIP_DRIVER_PAY_UNIT.FLAT:
      case 'FLAT':
        setTooltipText(
          `Driver pay estimated based on flat rate: $${grossPayData.gross_pay_estimate} ${
            enableOtherPayInDriverPayModal ? `+ $${otherPayItemsTotalAmount} other trip pay` : ''
          }`
        );
        break;

      default:
    }
  }, [grossPayData]);

  return (
    <Stack spacing={0.5} direction="row" alignItems="center">
      <TwTooltip title={tooltipText} placement="top">
        {showLabel ? <InfoIcon /> : <InfoOutlinedIcon sx={{ height: '16px' }} />}
      </TwTooltip>
      {showLabel && (
        <Typography
          variant="body2"
          fontWeight="400"
          fontSize="14px"
          color="#6B7280"
          sx={{ marginTop: '20px !important' }}
        >
          How it’s calculated?
        </Typography>
      )}
    </Stack>
  );
};

export default TwGrossPayTooltip;
